import { add, bignumber, format } from 'mathjs';

export function precisionAdd(...args) {
  return format(args.reduce((prev, current) => add(bignumber(+prev || 0), bignumber(+current || 0)), 0), { notation: 'fixed' });
}
